module.exports = __webpack_public_path__ + "img/home-2.877a816e.png";